import { Typography } from '@mui/material';
import { Theme, useTheme } from '@mui/material/styles';

import { Page } from '@/components/Layout/Page/Page';
import { PhoneForm } from '@/components/PageForm/PhoneForm';

import { getAssetPath } from '@/constants/configs';

import { useTranslate } from '@/hooks/useTranslate';

import { PROGRESS_STEPS } from '@/utils/progressSteps';

export function PhonePage() {
  const { t, language } = useTranslate();
  const theme = useTheme();
  return (
    <Page
      paperProps={{
        color: (theme: Theme) => theme.palette.primaries[200],
        position: 'right',
        size: 'medium',
        fgImgProps: {
          src: getAssetPath(`/phone-input-${language}.png`),
          overflowPercent: 50,
          width: 294,
        },
      }}
      hasLogo
      progressProps={PROGRESS_STEPS.phoneStep}
    >
      <Typography variant="h1">{t('phone.title')}</Typography>
      <Typography variant="body1" color={theme.palette.neutral[800]} mb={2}>
        {t('phone.description')}
      </Typography>
      <PhoneForm />
    </Page>
  );
}

export default PhonePage;
